module.exports = __webpack_public_path__ + "img/live-chat.3267368b.png";